import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { RoomBackdrop } from '../components/RoomBackdrop';
import { OFFERING_LIST } from '../data/offerings';
import './HomePage.css';

export function HomePage() {
  return (
    <>
      <RoomBackdrop room="home" dim={0} fit="contain" position="center center" />
      <main className="page home">
        <header className="home__intro">
          <h1 className="home__headline">Executive consulting to lead, transform, and govern.</h1>
        </header>

        <div className="home__paths" aria-label="What we do">
          {OFFERING_LIST.map((offer, i) => (
            <motion.div
              key={offer.id}
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.1 + i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            >
              <Link to={`/services?need=${offer.id}`} className="path-card">
                <h2 className="path-card__title">{offer.title}</h2>
                <p className="path-card__line">{offer.tagline}</p>
                <span className="path-card__more">Explore</span>
              </Link>
            </motion.div>
          ))}
        </div>
      </main>
    </>
  );
}
